export default __webpack_public_path__ + "static/media/dev3.378d4878.PNG";